import React from 'react'
import { Box } from '@mui/material'
import { pointText, batsuText } from '../../../lib/rule'

const PlayerWrong = ({ simple, rule, label }) => {
  const [pt, bt] = [pointText(simple), batsuText(simple)]

  const point = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {pt}
      </Box>
    </>
  )

  const batsu = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {bt}
      </Box>
    </>
  )

  const lock = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        休
      </Box>
    </>
  )

  const sw = rule.specialWrong
  const list = [(
    rule.pointWrong !== 0 && !sw.updown && !sw.backstream && !sw.divide &&
    <Box component="span" className="rule-content" key="point-wrong">
      {point(rule.pointWrong)}
    </Box>
  ), (
    sw.updown &&
    <Box component="span" className="rule-content" key="updown">
      {point(rule.initPoint)}に戻る
    </Box>
  ), (
    rule.batsuWrong !== 0 && !sw.swedish &&
    <Box component="span" className="rule-content" key="batsu-wrong">
      {batsu(rule.batsuWrong)}
    </Box>
  ), (
    sw.swedish &&
    <Box component="span" className="rule-content" key="swedish">
      {point(0)}ならば{batsu(1)}, {point('1,2')}ならば{batsu(2)}, {point('3,4,5')}ならば{batsu(3)}...
    </Box>
  ), (
    sw.backstream &&
    <Box component="span" className="rule-content" key="backstream">
      バツ数ポイント減
    </Box>
  ), (
    sw.freeze &&
    <Box component="span" className="rule-content" key="freeze">
      バツ数休
    </Box>
  ), (
    sw.divide &&
    <Box component="span" className="rule-content" key="divide">
      ポイントがバツ数で割った値になる
    </Box>
  ), (
    sw.belowLock &&
    <Box component="span" className="rule-content" key="below-lock">
      {point(rule.initPoint)}以下になると下回った数休
    </Box>
  ), (
    rule.lockWrong !== 0 && !sw.freeze && !sw.belowLock &&
    <Box component="span" className="rule-content" key="lock-wrong">
      {lock(rule.lockWrong)}
    </Box>
  )].filter(e => e)

  return list.length > 0 && (
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">{label || '誤答'}</Box>
      {list}
    </Box>
  )
}

export default PlayerWrong
